<template>
    <v-form
        ref="procedureForm"
        v-model="formValid"
    >
        <template v-if="procedureDataForm.previous_url != null || procedureDataForm.next_url != null || procedureDataForm.form.length > 0">
            <v-row v-if="valuesInit">
                <template v-for="formField in form">
                    <v-col
                            :cols="getColSize(formField, 'xs')"
                            :sm="getColSize(formField, 'sm')"
                            :md="getColSize(formField, 'md')"
                            :lg="getColSize(formField, 'lg')"
                            :key="formField.id"
                            v-if="validDependent(formField)"
                    >

                        <paragraph-field
                            v-if="formField.tipo === 'paragraph'"
                            :field="formField"
                        />
                        <TitleField
                            v-if="formField.tipo === 'title'"
                            :field="formField"
                        />
                        <SubtitleField
                            v-if="formField.tipo === 'subtitle'"
                            :field="formField"
                        />
                        <VariableField
                            v-if="formField.tipo === 'variable'"
                            :field="formField"
                        />

                            
                        <label v-if=" formField.tipo  !=  'javascript' 
                                && formField.tipo != 'paragraph' 
                                && formField.tipo != 'subtitle' 
                                && formField.tipo != 'title' 
                                && formField.tipo != 'variable' 
                                && formField.tipo != 'cart' 
                                && formField.tipo != 'map'
                                && formField.tipo != '<span> </span>'
                                && formField.etiqueta != '<span></span>'" class="text-family">
                                {{getLabel(formField)}}
                                <!-- {{formField}} -->
                        </label>
                        <text-field
                            v-if="formField.tipo === 'text'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                            :api-ajax="findApiAjaxDependent(formField)"
                            :stageId="procedureMeta.etapa_id"
                        />
                        <text-area
                            v-if="formField.tipo === 'textarea'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                        />
                        <SelectField
                            v-if="formField.tipo === 'select'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :stageId="procedureMeta.etapa_id"
                            :formValues="formValues"
                            :api-ajax="findApiAjaxDependent(formField)"
                        />
                        <DateField
                            v-if="formField.tipo === 'date'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                        />
                        <CheckboxField
                            v-if="formField.tipo === 'checkbox'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                            :dynamic-table="false"
                        />
                        <RadioField
                            v-if="formField.tipo === 'radio'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                        />
                        <QR
                            v-if="formField.tipo === 'qr'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                        />
                        <TableStaticField
                            v-if="formField.tipo === 'table_static'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                        />
                        <TableDynamicField
                            v-if="formField.tipo === 'table_dynamic'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                        />
                        <FileField
                            v-if="formField.tipo === 'file'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                            :dynamic-table="false"
                        />

                        <JavascriptField
                            v-if="formField.tipo === 'javascript'"
                            :field="formField"
                        />
                        <RedirectField
                            v-if="formField.tipo === 'redirect'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                        />
                        <MapField
                            v-if="formField.tipo === 'map'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                        />
                        <CartField
                            v-if="formField.tipo === 'cart'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                            :procedure-id="procedureMeta.tramite_id"
                            :stage-id="procedureMeta.etapa_id"
                        />

                        <DocumentField
                            v-if="formField.tipo === 'documento' || formField.tipo === 'signed_document'"
                            :field="formField"
                            :default_value="validateDefaultValue(formField)"
                        />

                        <SubmitField
                            v-if="formField.tipo === 'submit'"
                            :field="formField"
                            :default_value="validateDefaultValue(formField)"
                        />

                        <FirmaDigitalField
                            v-if="formField.tipo === 'firma'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                        />

                        <ApiAjaxField
                            v-if="formField.tipo === 'api_ajax'"
                            :field="formField"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                            :procedure-id="procedureMeta.tramite_id"
                            :stage-id="procedureMeta.etapa_id"
                        />

                    </v-col>
                </template>
            </v-row>
            <v-row>
                <v-col cols="12" class="d-flex justify-center">
                    <template v-if="procedureDataForm.previous_url != null">
                        <v-alert
                            v-if="procedureDataForm.status === 'sincontinuacion'"
                            v-bind:type="'error'"
                            dismissible
                        >
                            {{ procedureDataForm.api_message }}
                        </v-alert>
                        <v-btn
                            class="normal mr-2 white--text"  large :color="pantone"
                            @click="submitPreviousStep()"
                        >
                            <!-- <v-icon left>fas fa-chevron-left</v-icon> -->
                            Anterior
                        </v-btn>

                    </template>

                    <!-- DISABLE BUTTON FOR EFIRMA -->
                    <v-btn
                        v-if="procedureDataForm.next_url != null && procedureDataForm.status !== 'sincontinuacion'"
                        depressed
                        :color="pantoneBlack"
                        @click="submitNextStep"
                        large
                        class="btn btn-primary btn-siguiente white--text"
                    >
                        Siguiente
                    </v-btn>

                    <v-col cols="12" class="d-flex justify-center" v-if="procedureDataForm.next_url  == null && procedureDataForm.previous_url == null">
                        <router-link :to="{name: 'home'}">
                            <v-btn color="primary">Ir al inicio</v-btn>
                        </router-link>
                    </v-col>

                </v-col>
            </v-row>
        </template>
        <v-row v-else>
            <v-col cols="12">
                <v-alert :type="'info'" dismissible>
                    {{ procedureDataForm.api_message }}
                </v-alert>
            </v-col>
            <v-col cols="12" class="d-flex justify-center">
                <router-link :to="{name: 'home'}">
                    <v-btn color="primary">Ir al inicio</v-btn>
                </router-link>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
    import Vue from 'vue'
    import {mapGetters, mapState, mapActions} from "vuex";
    import evaluate from 'simple-evaluate'
    import {
        TextField, TextArea, ParagraphField, TitleField, SubtitleField, VariableField,
        SelectField, CheckboxField, RadioField, FileField,
        DateField, QR, TableStaticField, TableDynamicField,
        JavascriptField, RedirectField, MapField, CartField,
        DocumentField, FirmaDigitalField, SubmitField, ApiAjaxField
    } from './FormFields'
    import {bootstrapSizeToVuetify, expresionToArray} from "bestgob-core/core/utils";
    // eslint-disable-next-line no-unused-vars
    import {procedureSubmitNextRequest} from "bestgob-core/api/models";
import moment from 'moment';

    export default {

        computed: {
            ...mapState({proceduresStore: state => state.procedures}),
            ...mapGetters('procedures', ['procedureDataForm', 'form', 'procedureData', 'procedureMeta', 'returnLastCondition'])
        },
        components: {
            ParagraphField, TitleField, SubtitleField, VariableField,
            TextField, TextArea, SelectField, CheckboxField, RadioField,FileField,
            DateField, QR, TableStaticField, TableDynamicField,
            JavascriptField, RedirectField, MapField, CartField,
            DocumentField, FirmaDigitalField, SubmitField, ApiAjaxField
        },

        props: ['procedureAction'],

        data() {
            return {
                formValid: false,
                name: '',

                formValues: {},
                valuesInit: false,
                formComponentsVisible: {},
                apiAjaxComponents: {

                },
                pantone: '#ff8400',
                pantoneBlack: '#15212F',
                pantoneBackground: '#fff5d3',
                lastConditionDefault: [],
            }
        },

        updated() {
            if (!this.valuesInit && this.procedureDataForm != null){
                this.initFormValues()
                this.showFormErrors()
            }
        },

        methods: {
            ...mapActions('procedures', ['submitProcedureNextStep', 'getProcedureExecutedStep', 'setLastCondition']),
            ...mapGetters('procedures', ['isPostNextRequest', 'formErrors']),
            ...mapActions('alerts', ['success', 'warning', 'error']),

            initFormValues(){
                this.form.forEach((formField) => {
                    if (formField.tipo === 'firma'){
                        Vue.set(this.formValues, formField.datos.certificado.name, formField.datos.certificado.value)
                        Vue.set(this.formValues, 'original_message', formField.datos.final_sign_string)
                        if (formField.value != null && formField.value.signed_message != undefined){
                            Vue.set(this.formValues, 'signed_message', formField.value.signed_message)
                        }else {
                            Vue.set(this.formValues, 'signed_message', '')
                        }
                    }
                    else if (formField.tipo === 'table_dynamic'){
                        Vue.set(this.formValues, formField.nombre, JSON.stringify(formField.value))
                    }
                    else if (formField.tipo === 'file'){
                        Vue.set(this.formValues, formField.nombre, formField.decodeJson)
                    }else if (formField.tipo === 'api_ajax'){
                        this.addAndPrepareApiAjax(formField)
                    }
                    else if (!['paragraph', 'title', 'subtitle', 'api_ajax'].includes(formField.tipo)) {
                        Vue.set(this.formValues, formField.nombre, formField.value)
                    }

                    this.valuesInit = true
                })
            },

            submitNextStep(){
                this.$refs.procedureForm.validate()

                if (this.formValid){
                    this.removeUnnecessaryFormValues()

                    let request = procedureSubmitNextRequest()
                    request.processId = this.procedureMeta.proceso_id
                    request.lastAction = this.procedureAction
                    request.data = this.formValues
                    request.url = this.procedureDataForm.next_url.replace(process.env.VUE_APP_API_BASE_URL, '')

                    if (this.isPostNextRequest()){
                        this.submitProcedureNextStep(request)
                    }else{
                        this.getProcedureExecutedStep(request)
                    }
                }
            },

            submitPreviousStep(){
                let request = procedureSubmitNextRequest()
                request.lastAction = this.procedureAction
                request.url = this.procedureDataForm.previous_url.replace(process.env.VUE_APP_API_BASE_URL, '')
                request.processId = this.procedureMeta.proceso_id

                this.getProcedureExecutedStep(request)
            },

            /** Elimina valores cuyos componentes estan escondidos **/
            /** TODO: revisar para los de la Firma Digital **/
            removeUnnecessaryFormValues(){
                Object.keys(this.formValues).forEach(itemKey => {
                    if (this.formComponentsVisible[itemKey] !== undefined && !this.formComponentsVisible[itemKey]){
                        delete this.formValues[itemKey]
                    }else if (this.formValues[itemKey] === null){
                        delete this.formValues[itemKey]
                    }
                })
            },

            getColSize(field, size){
                let bootstrapSizes = ''
                if (field.extra != null && field.extra.tamano != null){
                    bootstrapSizes = field.extra.tamano
                }

                return bootstrapSizeToVuetify(bootstrapSizes, size)
            },

            /**
             * Try show Form errors if exists
             */
            showFormErrors(){
                let errors = this.proceduresStore.formErrors
                if (errors && typeof errors === 'object' ){
                    let messages = ''
                    Object.values(errors).forEach(message => {
                        if (messages !== ''){
                            messages += ', '
                        }

                        messages += message
                    })

                    if (messages !== ''){
                        this[errors['action_type']](errors['action_redirect'])
                    }
                }
            },

            validDependent(field){
                let isVisible = true

                if (field.dependiente_campo != null && field.dependiente_campo != ''){
                    isVisible = this.evaluateDependentExpresion(field.dependiente_campo)
                }

                this.formComponentsVisible[field.nombre] = isVisible

                return isVisible
            },

            validateFieldReadOnly(field){
                if (field.condicion_solo_lectura != null && field.condicion_solo_lectura != ''){
                    return ( ( field.readonly == 1 && this.evaluateDependentExpresion(field.condicion_solo_lectura) || this.procedureDataForm.meta.modo == "visualizacion"))
                }

                return (field.readonly == 1)
            },
            
            //funcion que se ejecuta cada que cambia el valor en tu componente
            validateDefaultValue(field){
                // field.condicion_valor_default ? (console.log(field.etiqueta, this.formValues[field.nombre] )) : 0 ;
                //valida que la condicion por default exista
                if ( field.condicion_valor_default != null && field.condicion_valor_default != ''){
                    
                    //evalua la condiccion y trae true o false dependiendo del resultado
                    let isValid = this.evaluateDependentExpresion(field.condicion_valor_default);
                    // console.log(isValid);
                    //para poner entrara  acambiar el valor es necesario la validacion anterior cambie, asi se previene que se quiera actualizar en cada cambio de valor
                    // console.log(this.lastConditionDefault);
                    // console.log(isValid);
                    if(this.returnLastCondition[field.nombre] != isValid ){
                        //si la condicion se cumple siempre cambia el valor del campo, (this.formValues[field.nombre] a el valor por default)
                        if (isValid){
                            this.formValues[field.nombre] = this.getVariableExpresionValue(field.valor_default)
                        }
                        else if (  !isValid && field.valor_default_no_cumple != null  ){
                            //date no estaba agarrando valor vacio o '' , entonces opte por poner la fecha actual
                            if( field.tipo == 'date' && field.valor_default_no_cumple == '' ){
                                this.formValues[field.nombre]= moment(new Date).format('YYYY-MM-DD')
                            }else{
                                this.formValues[field.nombre]= this.getVariableExpresionValue(field.valor_default_no_cumple)

                            }
                        }
                    }
                    this.lastConditionDefault[field.nombre] = isValid
                    this.setLastCondition( { nombre: field.nombre , isValid: isValid})
                }
            },

            evaluateDependentExpresion(originalExpression) {
                let expression = originalExpression.replace(/ and /g, " && ").replace(/ or /g, ' || ')
                expression = expression.split("->").join("andornotarrobj")


                let expressionArray = expresionToArray(expression)
                for (let i = 0; i < expressionArray.length; i++) {
                    if (expressionArray[i].includes('@@') || expressionArray[i].includes('@!') || expressionArray[i].includes('@#') || expressionArray[i].includes('@=') ) {

                        let expressionOriginal = expressionArray[i];
                        let fieldToCompare = expressionOriginal.trim().replace('@@', '').replace('@!', '').replace('@#', '').replace('@=', '').replace('(','').replace(')','')

                        let comparisonValue = this.formValues[fieldToCompare]

                        if (comparisonValue === undefined) {
                            comparisonValue = this.getValueFromProcessData(fieldToCompare)
                        }

                        let tipoVariable = '@@'
                        if(expression.search('@!'+fieldToCompare)!==-1){
                            tipoVariable = '@!';
                        }else if(expression.search('@#'+fieldToCompare)!==-1){
                            tipoVariable = '@#';
                        }else if(expression.search('@='+fieldToCompare)!==-1){
                            tipoVariable = '@=';
                        }

                        if(comparisonValue===null){
                            comparisonValue = 'undefined'
                        }

                        let valueFinal = `'${comparisonValue}'`
                        if(!isNaN(parseFloat(comparisonValue)) && isFinite(comparisonValue)){
                            valueFinal = `${comparisonValue}`;
                        }

                        expression = expression.replace(tipoVariable+fieldToCompare, valueFinal).replace('typeof','')

                    }
                }

                expression = expression.replaceAll("''", "'")

                return evaluate(null, expression)
            },

            getVariableExpresionValue(variableExpresion){
                if (variableExpresion?.includes('@@') || variableExpresion?.includes('@!')){
                    let variableName;
                    let hasBeentrimed = false;
                    if(variableExpresion?.includes('@!')){
                        variableName = variableExpresion.trim().replace('@!', '')
                        hasBeentrimed =true
                    }else if(variableExpresion?.includes('@@')){
                        variableName =variableExpresion?.trim().replace('@@', '')
                        hasBeentrimed =true
                    }
                    // let variableName = variableExpresion.trim().replace('@@', '').replace('@!', '')
                    //esta variable busca el valor en el formulario y si no hay valor entras a conseguir el valor del sistema, en teoria ya no es necesario  ya que para entrar a buscar ahora veo si se hice un trim o no, pero se queda para no pegarle a algo externo
                    let variableValue = this.formValues[variableName] 

                    // se agrego el curp como exepcion porque estaba regresando el mismo valor que el campo traia, ocacionando un error ,porque? buena pregunta   
                    if (variableValue == undefined || variableValue== null || variableValue=='' || hasBeentrimed ){
                        // console.lg(variableName);
                        variableValue = this.getValueFromProcessData(variableName)
                    }
                        // return variableValue
                        // if(variableValue != this.formValues[variableName])
                        return variableValue
                }

                return variableExpresion
            },

            getValueFromProcessData(valueReference) {
                let splitVal = '->'
                if(valueReference.search('andornotarrobj') !== -1){
                    splitVal = 'andornotarrobj'
                }

                let valueRefArray = valueReference.split(splitVal)
                if (valueRefArray.length === 1){
                    if(typeof this.procedureData[valueRefArray[0]] !== 'undefined'){
                        return this.procedureData[valueRefArray[0]]
                    }
                }else if (valueRefArray.length === 2){
                    if(typeof this.procedureData[valueRefArray[0]]!== 'undefined' && typeof this.procedureData[valueRefArray[0]][valueRefArray[1]]!== 'undefined'){
                        return this.procedureData[valueRefArray[0]][valueRefArray[1]]
                    }
                }else if (valueRefArray.length === 3){
                    if(typeof this.procedureData[valueRefArray[0]]!=='undefined' && typeof this.procedureData[valueRefArray[0]][valueRefArray[1]]!=='undefined' && typeof this.procedureData[valueRefArray[0]][valueRefArray[1]][valueRefArray[2]]!=='undefined'){
                        return this.procedureData[valueRefArray[0]][valueRefArray[1]][valueRefArray[2]]
                    }
                }else if (valueRefArray.length === 4){
                    if(typeof this.procedureData[valueRefArray[0]]!=='undefined' && typeof this.procedureData[valueRefArray[0]][valueRefArray[1]]!=='undefined' && typeof this.procedureData[valueRefArray[0]][valueRefArray[1]][valueRefArray[2]]!=='undefined' && typeof this.procedureData[valueRefArray[0]][valueRefArray[1]][valueRefArray[2]][valueRefArray[3]]!=='undefined'){
                        return this.procedureData[valueRefArray[0]][valueRefArray[1]][valueRefArray[2]][valueRefArray[3]]
                    }
                }
                return null
            },

            getLabel(field){
                if (field.validacion.required){
                    return '* ' + field.etiqueta
                }

                return field.etiqueta
            },

            findApiAjaxDependent(field){
                if (this.apiAjaxComponents[field.nombre] !== undefined){
                    console.log(this.apiAjaxComponents[field.nombre]);
                    return this.apiAjaxComponents[field.nombre]
                }

                return null
            },

            addAndPrepareApiAjax(field){
                field.extra.get_campos.forEach((fieldDependent, index) => {
                    let configApiAjaxItem = {
                      originFieldId: field.id,
                        originFieldName: field.nombre,
                        elementType: field.extra.get_tipo[index],
                        event: field.extra.get_valores[index]
                    }

                    let fieldDependentFinal = fieldDependent.replace(/@/g, '');
                    if (this.apiAjaxComponents[fieldDependentFinal] === undefined){
                        Vue.set(this.apiAjaxComponents, fieldDependentFinal, configApiAjaxItem)
                    }
                })
            }

        }


    };
</script>

<style>
    .hidden{display: none !important;}
</style>
